import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=1e2a3d69"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=1e2a3d69&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports